import React, { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import InjectedCheckoutForm from './InjectedCheckoutForm';

class CheckoutComponent extends Component {
	constructor(props) {
		super(props);

		this.handleStripeFormInit = this.handleStripeFormInit.bind(this);
		this.state = {
			stripeInstance: null
		};
	}

	componentDidMount() {
		const { paymentMethod: { configuration } } = this.props;
		const stripe = loadStripe(configuration.publishableApiKey, {
			stripeAccount: configuration.connectedAccountId   // perform calls on behalf of a connected Stripe account
		});
		this.setState({ stripeInstance: stripe });
	}

	handleStripeFormInit({ stripeSubmitHandle, stripePaymentHandle }) {
		this.props.onPaymentMethodInit(this.props.paymentMethod, { stripeSubmitHandle, stripePaymentHandle });
	}

	render() {
		const { payment, currency, countryCode, paymentMethod: { configuration } } = this.props;

		const options = {
			mode: 'payment',
			currency: currency.toLowerCase(),
			amount: Math.round(payment.totalAmount * 100),
			payment_method_configuration: configuration.paymentMethodConfigurationId
		};

		return <div className='description' style={{ marginTop: '20px' }}>
			<Elements stripe={this.state.stripeInstance} options={options}>
				<InjectedCheckoutForm onInit={this.handleStripeFormInit} payment={payment} countryCode={countryCode} />
			</Elements>
		</div>;
	}
}

export default CheckoutComponent;